var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwardBarFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 28,
    viewBox: "0 0 14 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.3561V0H14L1.91137 26.7677C1.46818 27.749 0 27.4329 0 26.3561Z",
    fill: "var(--PRIMARY_BACKGROUND_COLOR)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardBarFlag);
export default __webpack_public_path__ + "static/media/award-bar-flag.650fadde57e5613eff7dfaeaf7307f4f.svg";
export { ForwardRef as ReactComponent };